import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { validStEnpty } from "@/hooks/validate";
import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  name: "ExamDetail",
  components: {
    Head: Head
  },
  setup: function setup() {
    // const { globalProperties } = useCurrentInstance();
    var route = useRoute();
    var hu = ref(route.query.huid); // const router = useRouter();

    var allslists = reactive({
      list: {
        allpeerScore: 0,
        peerScore: '',
        listId: 8,
        title: "",
        selfDetail: [{
          optionId: 0,
          optionName: "",
          maxScore: 0
        }],
        selfOpinion: "",
        peerDetail: [{
          peerId: 160,
          sore: 0,
          peerDetail: [{
            optionId: 0,
            optionName: "",
            maxScore: 0
          }]
        }],
        secretaryDetail: [{
          optionId: 0,
          optionName: "",
          maxScore: 0
        }],
        secretaryOpinion: "2552"
      }
    });
    var store = useStore();
    var use = ref(route.query.logo);
    var alllist = reactive({
      list: [{
        participant: "",
        participantName: "",
        participantStatus: 0
      }]
    });
    var text = reactive({
      textarea: ''
    });
    var showis = ref("");

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var Datalist = reactive({
      topData: {
        startTime: "2022-01-04 13:13:10",
        endTime: "2022-01-13 00:00:00",
        leftData: [{
          label: "姓名",
          english: "",
          value: ""
        }, {
          label: "性别",
          english: "",
          value: ""
        }, {
          label: "出生日期",
          english: "",
          value: ""
        }, {
          label: "民族",
          english: "",
          value: ""
        }, {
          label: "手机号",
          english: "",
          value: ""
        }, {
          label: "党内职务",
          english: "",
          value: ""
        }, {
          label: "所在组织",
          english: "",
          value: ""
        }],
        rightData: [{
          label: "籍贯",
          english: "",
          value: ""
        }, {
          label: "学历",
          english: "",
          value: ""
        }, {
          label: "学位",
          english: "",
          value: ""
        }, {
          label: "入党时间",
          english: "",
          value: ""
        }, {
          label: "工作时间",
          english: "",
          value: ""
        }, {
          label: "转正时间",
          english: "",
          value: ""
        }]
      },
      tableList: [{
        title: "12987122",
        context: "awsdfasf",
        name: "Tom1",
        value: 0
      }, {
        title: "12987122",
        context: "awsdfasf",
        name: "Tom2",
        value: 0
      }, {
        title: "12987124",
        context: "awsdfasf",
        name: "Tom3",
        value: 0
      }, {
        title: "12987125",
        context: "awsdfasf",
        name: "Tom4",
        value: 0
      }, {
        title: "12987126",
        context: "awsdfasf",
        name: "Tom5",
        value: 0
      }],
      tableOnly: false
    });
    var sconumber = reactive({
      list: [{
        num: 0
      }]
    });
    var Data = reactive({
      topData: {
        bizAppraiseOptions: [],
        startTime: "",
        endTime: "",
        title: "",
        selfRate: "",
        peerRate: "",
        secretaryRate: ""
      },
      tableList: [{
        createTime: "",
        description: "",
        listId: "",
        maxScore: "",
        optionId: "",
        optionName: ""
      }],
      tableOnly: false
    });

    function show() {
      showis.value = String(route.query.logo);
    }

    var indexlist = ref(-1); //人id

    show();

    function lisone() {
      alllist.list.forEach(function (item, index) {
        if (item.participant == use.value) {
          if (index == alllist.list.length - 1) {
            indexlist.value = -1;
          } else {
            indexlist.value = index;
          }
        }
      });
    }

    function listwo() {
      console.log("shs");
      var ae = '';
      var num = 0;

      for (var i = 0; i < alllist.list.length; i++) {
        if (alllist.list[i].participantStatus == 0 && alllist.list[i].participantName != Datalist.topData.leftData[0].value) {
          num++;
          ae = alllist.list[i].participant;
          hu.value = ae;
          console.log(num, "shs", alllist.list[i]);
          peopleDetail(ae);
          return;
        }
      }

      console.log(num, 'num');

      if (num == 0) {
        var init = "互评";

        if (route.query.logo == "1") {
          init = "互评";
        }

        if (route.query.logo == "2") {
          init = "评议";
        }

        ElMessageBox.alert("\u5DF2\u5168\u90E8" + init, "提示", {
          confirmButtonText: "确定",
          callback: function callback(action) {
            console.log(action);
            router.back(); // router.push(
            // {
            //   path:'democracy', 
            //   query:{ 
            //   }
            // })
          }
        });
      }
    }

    function listshow(_x) {
      return _listshow.apply(this, arguments);
    }

    function _listshow() {
      _listshow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (val == 1) {
                  hispeopleDetail({
                    listId: route.query.listid,
                    userId: hu.value
                  });
                }

                console.log("11"); //自动下一人

                _context.next = 4;
                return lisone();

              case 4:
                _context.next = 6;
                return listwo();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _listshow.apply(this, arguments);
    }

    function hispeopleDetail(_x2) {
      return _hispeopleDetail.apply(this, arguments);
    }

    function _hispeopleDetail() {
      _hispeopleDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var res, allpeerScore;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["hispeopleDetail"](id);

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  allslists.list = res.data;

                  if (allslists.list.peerScore) {
                    if (!allslists.list.peerScore.indexOf(",")) {
                      allslists.list.allpeerScore = Number(allslists.list.peerScore);
                    } else {
                      allpeerScore = allslists.list.peerScore.split(",");
                      allslists.list.allpeerScore = 0;
                      allpeerScore.forEach(function (item) {
                        allslists.list.allpeerScore = allslists.list.allpeerScore + Number(item);
                      });
                    }
                  }

                  if (allslists.list.peerDetail) {
                    allslists.list.peerDetail.forEach(function (item) {
                      item.sore = 0;
                      item.peerDetail.forEach(function (ite) {
                        item.sore += ite.maxScore;
                      });
                    });
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _hispeopleDetail.apply(this, arguments);
    }

    if (route.query.logo == "2") {
      hispeopleDetail({
        listId: route.query.listid,
        userId: hu.value
      });
    }

    function peoplelist(_x3) {
      return _peoplelist.apply(this, arguments);
    }

    function _peoplelist() {
      _peoplelist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("1155"); //评议人列表

                _context3.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peoplelist"](id);

              case 3:
                res = _context3.sent;

                if (res.code == 0) {
                  alllist.list = res.data;

                  if (showis.value == String(2)) {
                    console.log(7766);
                    listshow(1);
                  } else {
                    console.log(77644746);
                    listshow(0);
                  }
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _peoplelist.apply(this, arguments);
    }

    function handleSubmit() {
      //提交
      var index = 0;
      sconumber.list.forEach(function (item) {
        if (item.num == 0) {
          index++;
        }
      });

      if (index > 0) {
        ElMessageBox.alert("\u8FD8\u6709".concat(index, "\u4E2A\u9898\u6CA1\u8BC4\u5206"), "提示", {
          confirmButtonText: "确定",
          callback: function callback(action) {
            console.log(action);
          }
        });
      } else {
        if (showis.value == "1") {
          tijia();
        } else {
          if (!validStEnpty(text.textarea)) {
            ElMessageBox.alert("\u8BF7\u586B\u5199\u8BC4\u4EF7", "提示", {
              confirmButtonText: "确定",
              callback: function callback(action) {
                console.log(action);
              }
            });
          } else {
            tijia();
          }
        }
      }
    }

    var showw = ref(true);

    function tijia() {
      ElMessageBox.confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        showw.value = false;
        var numf = 1;
        var time = setInterval(function () {
          numf++;

          if (numf == 5) {
            clearInterval(time);
            showw.value = true;
          }
        }, 1000);
        var add = {
          userId: "",
          secretaryProcessDTO: [{}],
          secretaryOpinion: "",
          secretaryScore: "",
          peerOption: [{}],
          peerUserIds: "",
          listId: Data.tableList[0].listId,
          optionDTOS: [{
            maxScore: sconumber.list[0].num,
            optionId: Data.tableList[0].optionId,
            optionName: Data.tableList[0].optionName
          }],
          selfOpinion: text.textarea,
          selfScore: "",
          peerRate: "",
          peerScore: ""
        };
        var number = sconumber.list[0].num;

        for (var i = 1; i < Data.tableList.length; i++) {
          add.optionDTOS.push({
            maxScore: sconumber.list[i].num,
            optionId: Data.tableList[i].optionId,
            optionName: Data.tableList[i].optionName
          });
          number += sconumber.list[i].num;
        }

        add.selfScore = String(number * parseInt(Data.topData.selfRate) / 100);

        if (showis.value == "0") {
          //自评
          selfProcess(add);
        }

        if (showis.value == "1") {
          //互评
          add.selfScore = "";
          add.peerScore = String(number * parseInt(Data.topData.peerRate) / 100);
          add.peerUserIds = String(store.state.user.user.userId);
          add.peerOption = [{
            peerDetail: add.optionDTOS,
            peerId: String(store.state.user.user.userId)
          }];
          add.userId = String(hu.value);
          add.optionDTOS = [];
          peerProcess(add);
        }

        if (showis.value == "2") {
          //书记评
          add.secretaryOpinion = add.selfOpinion;
          add.selfOpinion = "";
          add.selfScore = "";
          add.secretaryScore = String(number * parseInt(Data.topData.secretaryRate) / 100);
          add.secretaryProcessDTO = add.optionDTOS;
          add.optionDTOS = [];
          add.userId = String(hu.value);
          secretaryProcess(add);
        }
      }).catch(function () {
        console.log(1);
      });
    }

    function peopleDetail(_x4) {
      return _peopleDetail.apply(this, arguments);
    }

    function _peopleDetail() {
      _peopleDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peopleDetail"](id);

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  Datalist.topData.leftData[0].value = res.data.username;

                  if (res.data.gender == 0) {
                    Datalist.topData.leftData[1].value = "女";
                  } else {
                    Datalist.topData.leftData[1].value = "男";
                  }

                  Datalist.topData.leftData[2].value = res.data.birthday;
                  Datalist.topData.leftData[3].value = res.data.nationName;
                  Datalist.topData.leftData[4].value = res.data.mobile;
                  Datalist.topData.leftData[5].value = res.data.leaderIdentityName;
                  Datalist.topData.leftData[6].value = res.data.organizeName;
                  Datalist.topData.rightData[0].value = res.data.nativePlace;
                  Datalist.topData.rightData[1].value = res.data.educationName;
                  Datalist.topData.rightData[2].value = res.data.degreeName;
                  Datalist.topData.rightData[3].value = res.data.partyDate;
                  Datalist.topData.rightData[4].value = res.data.workingHours;
                  Datalist.topData.rightData[5].value = res.data.modifyDate;
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _peopleDetail.apply(this, arguments);
    }

    if (route.query.huid) {
      peopleDetail(route.query.huid);
    } else {
      peopleDetail(store.state.user.user.userId);
    }

    function questionDemocracy(_x5) {
      return _questionDemocracy.apply(this, arguments);
    }

    function _questionDemocracy() {
      _questionDemocracy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var res, i;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["questionDemocracy"](id);

              case 2:
                res = _context5.sent;

                if (res.code == 0) {
                  sconumber.list = [{
                    num: 0
                  }];
                  Data.topData = res.data;
                  Data.tableList = res.data.bizAppraiseOptions;

                  for (i = 1; i < Data.tableList.length; i++) {
                    sconumber.list.push({
                      num: 0
                    });
                  }
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _questionDemocracy.apply(this, arguments);
    }

    var router = useRouter();
    questionDemocracy(route.query.listid);

    function selfProcess(_x6) {
      return _selfProcess.apply(this, arguments);
    }

    function _selfProcess() {
      _selfProcess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
        var res, aa, time;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["selfProcess"](id);

              case 2:
                res = _context6.sent;

                if (res.code == 0) {
                  ElMessage({
                    type: "success",
                    message: "提交成功"
                  });
                  changeInfoTotal(id.listId, "\u6C11\u4E3B\u8BC4\u8BAE(\u81EA\u8BC4):".concat(Data.topData.title), 24);
                  aa = 0;
                  time = setInterval(function () {
                    aa++;
                    router.back(); // router.push(
                    //   {
                    //     path:'democracy', 
                    //     query:{ 
                    //     }
                    //   })

                    if (aa == 1) {
                      clearInterval(time);
                    }
                  }, 1000);
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _selfProcess.apply(this, arguments);
    }

    function peerProcess(_x7) {
      return _peerProcess.apply(this, arguments);
    }

    function _peerProcess() {
      _peerProcess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log("fd "); //互评提交

                _context7.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peerProcess"](id);

              case 3:
                res = _context7.sent;

                if (res.code == 0) {
                  text.textarea = '';
                  peoplelist({
                    listId: route.query.listid,
                    userId: store.state.user.user.userId
                  });
                  questionDemocracy(route.query.listid);
                  ElMessage({
                    type: "success",
                    message: "提交成功"
                  });
                  changeInfoTotal(id.listId, "\u6C11\u4E3B\u8BC4\u8BAE(\u4E92\u8BC4):".concat(Data.topData.title), 24);
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _peerProcess.apply(this, arguments);
    }

    function secretaryProcess(_x8) {
      return _secretaryProcess.apply(this, arguments);
    }

    function _secretaryProcess() {
      _secretaryProcess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["secretaryProcess"](id);

              case 2:
                res = _context8.sent;

                if (res.code == 0) {
                  text.textarea = '';
                  peoplelist({
                    listId: route.query.listid,
                    userId: store.state.user.user.userId
                  });
                  questionDemocracy(route.query.listid);
                  ElMessage({
                    type: "success",
                    message: "操作成功"
                  });
                  changeInfoTotal(id.listId, "\u6C11\u4E3B\u8BC4\u8BAE(\u4E66\u8BB0\u8BC4\u8BAE):".concat(Data.topData.title), 24);
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _secretaryProcess.apply(this, arguments);
    }

    function change() {
      //折叠面
      console.log();
    }

    return {
      Data: Data,
      text: text,
      // getListDetail,
      handleSubmit: handleSubmit,
      questionDemocracy: questionDemocracy,
      change: change,
      showis: showis,
      sconumber: sconumber,
      selfProcess: selfProcess,
      peerProcess: peerProcess,
      Datalist: Datalist,
      allslists: allslists,
      showw: showw
    };
  }
});